export default __webpack_public_path__ + "static/media/bg-savingDetails.9bf83111.jpg";